import LoadingSwitcher from "../../../general/loading/LoadingSwitcher";
import CartAddress from "../info/CartAddress";
import TextArea from "../../../../../components/general/input/TextArea";
import {useRef, useEffect} from "react";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import useSession from "../../../../services/state/session/useSession";

const CartDeliverySelection = ({ bpLocations, onBack }) => {

    const session = useSession();
    const setSelected = useCheckoutStore(state => state.setSelectedLocation);
    const locations = bpLocations.locations ?? [];

    return (
        <LoadingSwitcher loading={bpLocations.loading}>
            {locations.map((location, i) =>
                <div key={i}>
                    <p className="cart-h">{location.Name}</p>
                    <CartAddress address={location.C_Location_ID} />
                    <p className="clickable-text"
                       onClick={() => setSelected(session, location)}
                    >
                        Use this address
                    </p>
                </div>
            )}
            <p className="clickable-text" onClick={() => onBack()}>Back</p>
        </LoadingSwitcher>
    )
}

const CartLocation = ({ bpLocations, setLocation, deliveryViaRule, onChange }) => {

    const deliveryMessage = deliveryViaRule === 'D' ? "Delivering to " : "Assigned to ";
    const address = setLocation?.C_Location_ID;
    const note = setLocation?.X_DeliveryNote;
    const ref = useRef();

    const clearInput = useCheckoutStore(state => state.clearInput);

    return (
        <div className="cart-sub-section">
            <LoadingSwitcher loading={bpLocations.loading}>
                <div className="cart-info-split">
                    <p className="cart-h">{deliveryMessage}{setLocation?.Name}</p>
                    <p className="clickable-text"
                       onClick={() => clearInput('locationID')}
                    >
                        Change
                    </p>
                </div>
                <CartAddress address={address}/>
                <TextArea
                    style={{marginTop: "12px"}}
                    defaultValue={note}
                    hint="Location Delivery Note"
                    className="cart-input"
                    onChange={(e) => {
                        ref.current = e.target.value;
                    }}
                    onBlur={() =>
                        ref.current && (note !== ref.current) && bpLocations.updateDeliveryNote(setLocation, ref.current)
                    }
                />
            </LoadingSwitcher>
        </div>
    )

}

const CartDeliveryLocation = ({bpLocations, selected, orderLocation}) => {

    const session = useSession();
    const setSelected = useCheckoutStore(state => state.setSelectedLocation);
    // Auto-select if there's only one address
    useEffect(() => {
        const locations = bpLocations.locations ?? [];
        if (!bpLocations.loading && !selected && locations.length === 1) {
            setSelected(session, locations[0]);
        }
    }, [bpLocations.loading, bpLocations.locations, selected, session, setSelected]);

    return (
        <>
            {selected ?
                <CartLocation
                    setLocation={orderLocation}
                    bpLocations={bpLocations}
                /> :
                <CartDeliverySelection
                    bpLocations={bpLocations}
                />
            }
        </>
    )

}

export default CartDeliveryLocation;
